(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4057],{

/***/ 44133:
/***/ (function(module) {

"use strict";


// do not edit .js files directly - edit src/index.jst


  var envHasBigInt64Array = typeof BigInt64Array !== 'undefined';


module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }


    if ((a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      for (i of a.entries())
        if (!b.has(i[0])) return false;
      for (i of a.entries())
        if (!equal(i[1], b.get(i[0]))) return false;
      return true;
    }

    if ((a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      for (i of a.entries())
        if (!b.has(i[0])) return false;
      return true;
    }

    if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }


    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        continue;
      }

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};


/***/ }),

/***/ 86628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ Ot; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);
function e(){return(e=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t}).apply(this,arguments)}const n=(/* unused pure expression or super */ null && (["children","options"])),r=["allowFullScreen","allowTransparency","autoComplete","autoFocus","autoPlay","cellPadding","cellSpacing","charSet","className","classId","colSpan","contentEditable","contextMenu","crossOrigin","encType","formAction","formEncType","formMethod","formNoValidate","formTarget","frameBorder","hrefLang","inputMode","keyParams","keyType","marginHeight","marginWidth","maxLength","mediaGroup","minLength","noValidate","radioGroup","readOnly","rowSpan","spellCheck","srcDoc","srcLang","srcSet","tabIndex","useMap"].reduce((t,e)=>(t[e.toLowerCase()]=e,t),{for:"htmlFor"}),o={amp:"&",apos:"'",gt:">",lt:"<",nbsp:" ",quot:"“"},c=["style","script"],a=/([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi,u=/mailto:/i,i=/\n{2,}$/,l=/^( *>[^\n]+(\n[^\n]+)*\n*)+\n{2,}/,s=/^ *> ?/gm,_=/^ {2,}\n/,f=/^(?:( *[-*_]) *){3,}(?:\n *)+\n/,d=/^\s*(`{3,}|~{3,}) *(\S+)? *\n([\s\S]+?)\s*\1 *(?:\n *)+\n?/,p=/^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/,g=/^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,m=/^(?:\n *)*\n/,y=/\r\n?/g,h=/^\[\^([^\]]+)](:.*)\n/,k=/^\[\^([^\]]+)]/,x=/\f/g,b=/^\s*?\[(x|\s)\]/,v=/^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/,S=/^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/,$=/^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?([^>]*)\/{0}>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1)[\s\S])*?)<\/\1>\n*/i,w=/&([a-z]+);/g,z=/^<!--[\s\S]*?(?:-->)/,E=/^(data|aria|x)-[a-z_][a-z\d_.-]*$/,A=/^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i,R=/^\{.*\}$/,I=/^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,M=/^<([^ >]+@[^ >]+)>/,O=/^<([^ >]+:\/[^ >]+)>/,B=/ *\n+$/,L=/(?:^|\n)( *)$/,T=/-([a-z])?/gi,j=/^(.*\|?.*)\n *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*)\n?/,C=/^\[([^\]]*)\]:\s*(\S+)\s*("([^"]*)")?/,D=/^!\[([^\]]*)\] ?\[([^\]]*)\]/,N=/^\[([^\]]*)\] ?\[([^\]]*)\]/,Z=/(\[|\])/g,F=/(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/,P=/\t/g,G=/^ *\| */,H=/(^ *\||\| *$)/g,q=/ *$/,U=/^ *:-+: *$/,V=/^ *:-+ *$/,W=/^ *-+: *$/,Q=/^([*_])\1((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1\1(?!\1)/,X=/^([*_])((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1(?!\1|\w)/,J=/^~~((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)~~/,K=/^\\([^0-9A-Za-z\s])/,Y=/^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i,tt=/^\n+/,et=/^([ \t]*)/,nt=/\\([^0-9A-Z\s])/gi,rt=new RegExp("^( *)((?:[*+-]|\\d+\\.)) +"),ot=new RegExp("^( *)((?:[*+-]|\\d+\\.)) +[^\\n]*(?:\\n(?!\\1(?:[*+-]|\\d+\\.) )[^\\n]*)*(\\n|$)","gm"),ct=new RegExp("^( *)((?:[*+-]|\\d+\\.)) [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1(?:[*+-]|\\d+\\.) (?!(?:[*+-]|\\d+\\.) ))\\n*|\\s*\\n*$)"),at="(?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*",ut=new RegExp("^\\[("+at+")\\]\\(\\s*<?((?:[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"),it=new RegExp("^!\\[("+at+")\\]\\(\\s*<?((?:[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"),lt=[l,p,d,v,S,z,ot,ct,j],st=[...lt,/^[^\n]+(?:  \n|\n{2,})/,$,A];function _t(t){return t.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g,"a").replace(/[çÇ]/g,"c").replace(/[ðÐ]/g,"d").replace(/[ÈÉÊËéèêë]/g,"e").replace(/[ÏïÎîÍíÌì]/g,"i").replace(/[Ññ]/g,"n").replace(/[øØœŒÕõÔôÓóÒò]/g,"o").replace(/[ÜüÛûÚúÙù]/g,"u").replace(/[ŸÿÝý]/g,"y").replace(/[^a-z0-9- ]/gi,"").replace(/ /gi,"-").toLowerCase()}function ft(t){return W.test(t)?"right":U.test(t)?"center":V.test(t)?"left":null}function dt(t,e,n){const r=n.t;n.t=!0;const o=e(t.trim(),n);n.t=r;let c=[[]];return o.forEach(function(t,e){"tableSeparator"===t.type?0!==e&&e!==o.length-1&&c.push([]):("text"!==t.type||null!=o[e+1]&&"tableSeparator"!==o[e+1].type||(t.content=t.content.replace(q,"")),c[c.length-1].push(t))}),c}function pt(t,e,n){n.o=!0;const r=dt(t[1],e,n),o=t[2].replace(H,"").split("|").map(ft),c=function(t,e,n){return t.trim().split("\n").map(function(t){return dt(t,e,n)})}(t[3],e,n);return n.o=!1,{align:o,cells:c,header:r,type:"table"}}function gt(t,e){return null==t.align[e]?{}:{textAlign:t.align[e]}}function mt(t){return function(e,n){return n.o?t.exec(e):null}}function yt(t){return function(e,n){return n.o||n.u?t.exec(e):null}}function ht(t){return function(e,n){return n.o||n.u?null:t.exec(e)}}function kt(t){return function(e){return t.exec(e)}}function xt(t,e,n){if(e.o||e.u)return null;if(n&&!n.endsWith("\n"))return null;let r="";t.split("\n").every(t=>!lt.some(e=>e.test(t))&&(r+=t+"\n",t.trim()));const o=r.trimEnd();return""==o?null:[r,o]}function bt(t){try{if(decodeURIComponent(t).replace(/[^A-Za-z0-9/:]/g,"").match(/^\s*(javascript|vbscript|data):/i))return null}catch(t){return null}return t}function vt(t){return t.replace(nt,"$1")}function St(t,e,n){const r=n.o||!1,o=n.u||!1;n.o=!0,n.u=!0;const c=t(e,n);return n.o=r,n.u=o,c}function $t(t,e,n){const r=n.o||!1,o=n.u||!1;n.o=!1,n.u=!0;const c=t(e,n);return n.o=r,n.u=o,c}function wt(t,e,n){return n.o=!1,t(e+"\n\n",n)}const zt=(t,e,n)=>({content:St(e,t[1],n)});function Et(){return{}}function At(){return null}function Rt(...t){return t.filter(Boolean).join(" ")}function It(t,e,n){let r=t;const o=e.split(".");for(;o.length&&(r=r[o[0]],void 0!==r);)o.shift();return r||n}var Mt;function Ot(n,H={}){H.overrides=H.overrides||{},H.slugify=H.slugify||_t,H.namedCodesToUnicode=H.namedCodesToUnicode?e({},o,H.namedCodesToUnicode):o;const q=H.createElement||react__WEBPACK_IMPORTED_MODULE_0__.createElement;function U(t,n,...r){const o=It(H.overrides,`${t}.props`,{});return q(function(t,e){const n=It(e,t);return n?"function"==typeof n||"object"==typeof n&&"render"in n?n:It(e,`${t}.component`,t):t}(t,H.overrides),e({},n,o,{className:Rt(null==n?void 0:n.className,o.className)||void 0}),...r)}function V(e){let n=!1;H.forceInline?n=!0:H.forceBlock||(n=!1===F.test(e));const r=dt(ft(n?e:`${e.trimEnd().replace(tt,"")}\n\n`,{o:n}));for(;"string"==typeof r[r.length-1]&&!r[r.length-1].trim();)r.pop();if(null===H.wrapper)return r;const o=H.wrapper||(n?"span":"div");let c;if(r.length>1||H.forceWrapper)c=r;else{if(1===r.length)return c=r[0],"string"==typeof c?U("span",{key:"outer"},c):c;c=null}return react__WEBPACK_IMPORTED_MODULE_0__.createElement(o,{key:"outer"},c)}function W(e){const n=e.match(a);return n?n.reduce(function(e,n,o){const c=n.indexOf("=");if(-1!==c){const a=function(t){return-1!==t.indexOf("-")&&null===t.match(E)&&(t=t.replace(T,function(t,e){return e.toUpperCase()})),t}(n.slice(0,c)).trim(),u=function(t){const e=t[0];return('"'===e||"'"===e)&&t.length>=2&&t[t.length-1]===e?t.slice(1,-1):t}(n.slice(c+1).trim()),i=r[a]||a,l=e[i]=function(t,e){return"style"===t?e.split(/;\s?/).reduce(function(t,e){const n=e.slice(0,e.indexOf(":"));return t[n.replace(/(-[a-z])/g,t=>t[1].toUpperCase())]=e.slice(n.length+1).trim(),t},{}):"href"===t?bt(e):(e.match(R)&&(e=e.slice(1,e.length-1)),"true"===e||"false"!==e&&e)}(a,u);"string"==typeof l&&($.test(l)||A.test(l))&&(e[i]=react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(V(l.trim()),{key:o}))}else"style"!==n&&(e[r[n]||n]=!0);return e},{}):void 0}const nt=[],at={},lt={blockQuote:{i:ht(l),l:Mt.HIGH,_:(t,e,n)=>({content:e(t[0].replace(s,""),n)}),p:(t,e,n)=>U("blockquote",{key:n.g},e(t.content,n))},breakLine:{i:kt(_),l:Mt.HIGH,_:Et,p:(t,e,n)=>U("br",{key:n.g})},breakThematic:{i:ht(f),l:Mt.HIGH,_:Et,p:(t,e,n)=>U("hr",{key:n.g})},codeBlock:{i:ht(p),l:Mt.MAX,_:t=>({content:t[0].replace(/^ {4}/gm,"").replace(/\n+$/,""),lang:void 0}),p:(t,e,n)=>U("pre",{key:n.g},U("code",{className:t.lang?`lang-${t.lang}`:""},t.content))},codeFenced:{i:ht(d),l:Mt.MAX,_:t=>({content:t[3],lang:t[2]||void 0,type:"codeBlock"})},codeInline:{i:yt(g),l:Mt.LOW,_:t=>({content:t[2]}),p:(t,e,n)=>U("code",{key:n.g},t.content)},footnote:{i:ht(h),l:Mt.MAX,_:t=>(nt.push({footnote:t[2],identifier:t[1]}),{}),p:At},footnoteReference:{i:mt(k),l:Mt.HIGH,_:t=>({content:t[1],target:`#${H.slugify(t[1])}`}),p:(t,e,n)=>U("a",{key:n.g,href:bt(t.target)},U("sup",{key:n.g},t.content))},gfmTask:{i:mt(b),l:Mt.HIGH,_:t=>({completed:"x"===t[1].toLowerCase()}),p:(t,e,n)=>U("input",{checked:t.completed,key:n.g,readOnly:!0,type:"checkbox"})},heading:{i:ht(v),l:Mt.HIGH,_:(t,e,n)=>({content:St(e,t[2],n),id:H.slugify(t[2]),level:t[1].length}),p:(t,e,n)=>(t.tag=`h${t.level}`,U(t.tag,{id:t.id,key:n.g},e(t.content,n)))},headingSetext:{i:ht(S),l:Mt.MAX,_:(t,e,n)=>({content:St(e,t[1],n),level:"="===t[2]?1:2,type:"heading"})},htmlComment:{i:kt(z),l:Mt.HIGH,_:()=>({}),p:At},image:{i:yt(it),l:Mt.HIGH,_:t=>({alt:t[1],target:vt(t[2]),title:t[3]}),p:(t,e,n)=>U("img",{key:n.g,alt:t.alt||void 0,title:t.title||void 0,src:bt(t.target)})},link:{i:mt(ut),l:Mt.LOW,_:(t,e,n)=>({content:$t(e,t[1],n),target:vt(t[2]),title:t[3]}),p:(t,e,n)=>U("a",{key:n.g,href:bt(t.target),title:t.title},e(t.content,n))},linkAngleBraceStyleDetector:{i:mt(O),l:Mt.MAX,_:t=>({content:[{content:t[1],type:"text"}],target:t[1],type:"link"})},linkBareUrlDetector:{i:(t,e)=>e.m?null:mt(I)(t,e),l:Mt.MAX,_:t=>({content:[{content:t[1],type:"text"}],target:t[1],title:void 0,type:"link"})},linkMailtoDetector:{i:mt(M),l:Mt.MAX,_(t){let e=t[1],n=t[1];return u.test(n)||(n="mailto:"+n),{content:[{content:e.replace("mailto:",""),type:"text"}],target:n,type:"link"}}},list:{i(t,e,n){const r=L.exec(n);return!r||!e.h&&e.o?null:ct.exec(t=r[1]+t)},l:Mt.HIGH,_(t,e,n){const r=t[2],o=r.length>1,c=o?+r:void 0,a=t[0].replace(i,"\n").match(ot);let u=!1;return{items:a.map(function(t,r){const o=rt.exec(t)[0].length,c=new RegExp("^ {1,"+o+"}","gm"),i=t.replace(c,"").replace(rt,""),l=r===a.length-1,s=-1!==i.indexOf("\n\n")||l&&u;u=s;const _=n.o,f=n.h;let d;n.h=!0,s?(n.o=!1,d=i.replace(B,"\n\n")):(n.o=!0,d=i.replace(B,""));const p=e(d,n);return n.o=_,n.h=f,p}),ordered:o,start:c}},p:(t,e,n)=>U(t.ordered?"ol":"ul",{key:n.g,start:t.start},t.items.map(function(t,r){return U("li",{key:r},e(t,n))}))},newlineCoalescer:{i:ht(m),l:Mt.LOW,_:Et,p:()=>"\n"},paragraph:{i:xt,l:Mt.LOW,_:zt,p:(t,e,n)=>U("p",{key:n.g},e(t.content,n))},ref:{i:mt(C),l:Mt.MAX,_:t=>(at[t[1]]={target:t[2],title:t[4]},{}),p:At},refImage:{i:yt(D),l:Mt.MAX,_:t=>({alt:t[1]||void 0,ref:t[2]}),p:(t,e,n)=>U("img",{key:n.g,alt:t.alt,src:bt(at[t.ref].target),title:at[t.ref].title})},refLink:{i:mt(N),l:Mt.MAX,_:(t,e,n)=>({content:e(t[1],n),fallbackContent:e(t[0].replace(Z,"\\$1"),n),ref:t[2]}),p:(t,e,n)=>at[t.ref]?U("a",{key:n.g,href:bt(at[t.ref].target),title:at[t.ref].title},e(t.content,n)):U("span",{key:n.g},e(t.fallbackContent,n))},table:{i:ht(j),l:Mt.HIGH,_:pt,p:(t,e,n)=>U("table",{key:n.g},U("thead",null,U("tr",null,t.header.map(function(r,o){return U("th",{key:o,style:gt(t,o)},e(r,n))}))),U("tbody",null,t.cells.map(function(r,o){return U("tr",{key:o},r.map(function(r,o){return U("td",{key:o,style:gt(t,o)},e(r,n))}))})))},tableSeparator:{i:function(t,e){return e.t?G.exec(t):null},l:Mt.HIGH,_:function(){return{type:"tableSeparator"}},p:()=>" | "},text:{i:kt(Y),l:Mt.MIN,_:t=>({content:t[0].replace(w,(t,e)=>H.namedCodesToUnicode[e]?H.namedCodesToUnicode[e]:t)}),p:t=>t.content},textBolded:{i:yt(Q),l:Mt.MED,_:(t,e,n)=>({content:e(t[2],n)}),p:(t,e,n)=>U("strong",{key:n.g},e(t.content,n))},textEmphasized:{i:yt(X),l:Mt.LOW,_:(t,e,n)=>({content:e(t[2],n)}),p:(t,e,n)=>U("em",{key:n.g},e(t.content,n))},textEscaped:{i:yt(K),l:Mt.HIGH,_:t=>({content:t[1],type:"text"})},textStrikethroughed:{i:yt(J),l:Mt.LOW,_:zt,p:(t,e,n)=>U("del",{key:n.g},e(t.content,n))}};!0!==H.disableParsingRawHTML&&(lt.htmlBlock={i:kt($),l:Mt.HIGH,_(t,e,n){const[,r]=t[3].match(et),o=new RegExp(`^${r}`,"gm"),a=t[3].replace(o,""),u=(i=a,st.some(t=>t.test(i))?wt:St);var i;const l=t[1].toLowerCase(),s=-1!==c.indexOf(l);n.m=n.m||"a"===l;const _=s?t[3]:u(e,a,n);return n.m=!1,{attrs:W(t[2]),content:_,noInnerParse:s,tag:s?l:t[1]}},p:(t,n,r)=>U(t.tag,e({key:r.g},t.attrs),t.noInnerParse?t.content:n(t.content,r))},lt.htmlSelfClosing={i:kt(A),l:Mt.HIGH,_:t=>({attrs:W(t[2]||""),tag:t[1]}),p:(t,n,r)=>U(t.tag,e({},t.attrs,{key:r.g}))});const ft=function(t){let e=Object.keys(t);function n(r,o){let c=[],a="";for(;r;){let u=0;for(;u<e.length;){const i=e[u],l=t[i],s=l.i(r,o,a);if(s){const t=s[0];r=r.substring(t.length);const e=l._(s,n,o);null==e.type&&(e.type=i),c.push(e),a=t;break}u++}}return c}return e.sort(function(e,n){let r=t[e].l,o=t[n].l;return r!==o?r-o:e<n?-1:1}),function(t,e){return n(function(t){return t.replace(y,"\n").replace(x,"").replace(P,"    ")}(t),e)}}(lt),dt=(Ot=function(t){return function(e,n,r){return t[e.type].p(e,n,r)}}(lt),function t(e,n={}){if(Array.isArray(e)){const r=n.g,o=[];let c=!1;for(let r=0;r<e.length;r++){n.g=r;const a=t(e[r],n),u="string"==typeof a;u&&c?o[o.length-1]+=a:null!==a&&o.push(a),c=u}return n.g=r,o}return Ot(e,t,n)});var Ot;const Bt=V(n);return nt.length?U("div",null,Bt,U("footer",{key:"footer"},nt.map(function(t){return U("div",{id:H.slugify(t.identifier),key:t.identifier},t.identifier,dt(ft(t.footnote,{o:!0})))}))):Bt}!function(t){t[t.MAX=0]="MAX",t[t.HIGH=1]="HIGH",t[t.MED=2]="MED",t[t.LOW=3]="LOW",t[t.MIN=4]="MIN"}(Mt||(Mt={}));/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (e=>{let{children:r,options:o}=e,c=function(t,e){if(null==t)return{};var n,r,o={},c=Object.keys(t);for(r=0;r<c.length;r++)e.indexOf(n=c[r])>=0||(o[n]=t[n]);return o}(e,n);return t.cloneElement(Ot(r,o),c)});
//# sourceMappingURL=index.modern.js.map


/***/ }),

/***/ 33809:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coronavirus",
      function () {
        return __webpack_require__(41843);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 98196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v5_CitiesAutocomplete; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var src_i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/utils/stateUtils.ts + 1 modules
var stateUtils = __webpack_require__(83202);
// EXTERNAL MODULE: ./src/components/v5/CitiesAutocomplete.module.scss
var CitiesAutocomplete_module = __webpack_require__(93408);
var CitiesAutocomplete_module_default = /*#__PURE__*/__webpack_require__.n(CitiesAutocomplete_module);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListSubheader/ListSubheader.js
var ListSubheader = __webpack_require__(53800);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(35606);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(24262);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js + 31 modules
var TextField = __webpack_require__(37988);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(55688);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Autocomplete/Autocomplete.js + 5 modules
var Autocomplete = __webpack_require__(63970);
// EXTERNAL MODULE: ./node_modules/autosuggest-highlight/match/index.js
var match = __webpack_require__(73579);
var match_default = /*#__PURE__*/__webpack_require__.n(match);
// EXTERNAL MODULE: ./node_modules/autosuggest-highlight/parse/index.js
var parse = __webpack_require__(16974);
var parse_default = /*#__PURE__*/__webpack_require__.n(parse);
// EXTERNAL MODULE: ./node_modules/react-window/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(6528);
;// CONCATENATED MODULE: ./src/components/v5/LongAutocomplete.tsx






// @ts-expect-error TS7016: Could not find a declaration file for module 'autosuggest-highlight/match'. '/Users/goksel/Sites/carbon-website-next/node_modules/autosuggest-highlight/match/index.js' implicitly has an 'any' type.

// @ts-expect-error TS7016: Could not find a declaration file for module 'autosuggest-highlight/parse'. '/Users/goksel/Sites/carbon-website-next/node_modules/autosuggest-highlight/parse/index.js' implicitly has an 'any' type.



const LISTBOX_PADDING = 8; // px
function renderRow(props) {
    const { data , index , style  } = props;
    return /*#__PURE__*/ react.cloneElement(data[index], {
        style: {
            ...style,
            top: style.top + LISTBOX_PADDING
        }
    });
}
const OuterElementContext = /*#__PURE__*/ react.createContext({});
const OuterElementContextWrapper = (props, ref)=>{
    const outerProps = react.useContext(OuterElementContext);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref,
        ...props,
        ...outerProps
    });
};
OuterElementContextWrapper.displayName = "OuterElementContextWrapper";
const OuterElementType = /*#__PURE__*/ react.forwardRef(OuterElementContextWrapper);
function useResetCache(data) {
    const ref = react.useRef(null);
    react.useEffect(()=>{
        if (ref.current != null) {
            ref.current.resetAfterIndex(0, true);
        }
    }, [
        data
    ]);
    return ref;
}
// Adapter for react-window
const ListboxComponent = /*#__PURE__*/ react.forwardRef(function ListboxComponent(props, ref) {
    const { children , ...other } = props;
    const itemData = react.Children.toArray(children);
    const theme = (0,useTheme/* default */.Z)();
    const smUp = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("sm"), {
        noSsr: true
    });
    const itemCount = itemData.length;
    const itemSize = smUp ? 36 : 48;
    const getChildSize = (child)=>{
        if (/*#__PURE__*/ react.isValidElement(child) && child.type === ListSubheader/* default */.Z) {
            return 48;
        }
        return itemSize;
    };
    const getHeight = ()=>{
        if (itemCount > 8) {
            return 8 * itemSize;
        }
        return itemData.map(getChildSize).reduce((a, b)=>a + b, 0);
    };
    const gridRef = useResetCache(itemCount);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OuterElementContext.Provider, {
            value: other,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VariableSizeList */.S_, {
                itemData: itemData,
                height: getHeight() + 2 * LISTBOX_PADDING,
                width: "100%",
                ref: gridRef,
                outerElementType: OuterElementType,
                innerElementType: "ul",
                itemSize: (index)=>getChildSize(itemData[index]),
                overscanCount: 5,
                itemCount: itemCount,
                children: renderRow
            })
        })
    });
});
const useStyles = (0,makeStyles/* default */.Z)({
    listbox: {
        boxSizing: "border-box",
        "& ul": {
            padding: 0,
            margin: 0
        }
    }
});
const renderGroup = (params)=>[
        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListSubheader/* default */.Z, {
            component: "div",
            children: params.group
        }, params.key),
        params.children
    ];
const LongAutocomplete = (param)=>{
    let { options , onChange , label , className , disabled , clearOnEscape  } = param;
    const classes = useStyles();
    const [inputValue, setInputValue] = (0,react.useState)("");
    const [open, setOpen] = (0,react.useState)(false);
    const handleOpen = ()=>{
        if (inputValue.length > 0) {
            setOpen(true);
        }
    };
    // @ts-expect-error TS7006, TS7006: Parameter 'event' implicitly has an 'any' type.,  Parameter 'newInputValue' implicitly has an 'any' type.
    const handleInputChange = (event, newInputValue)=>{
        setInputValue(newInputValue);
        if (newInputValue.length > 0) {
            setOpen(true);
        } else {
            setOpen(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.ZP, {
        disableListWrap: true,
        classes: classes,
        className: className,
        ListboxComponent: ListboxComponent,
        renderGroup: renderGroup,
        options: options,
        renderInput: (params)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                ...params,
                variant: "outlined",
                placeholder: label,
                type: "search"
            }),
        // @ts-expect-error TS2322: Type 'AutocompleteOnChange' is not assignable to type '(event: ChangeEvent<{}>, value: string, reason: AutocompleteChangeReason, details?: AutocompleteChangeDetails<string> | undefined) => void'.
        onChange: onChange,
        disableClearable: true,
        clearOnEscape: clearOnEscape,
        freeSolo: true,
        open: open,
        onOpen: handleOpen,
        onClose: ()=>setOpen(false),
        inputValue: inputValue,
        onInputChange: handleInputChange,
        autoHighlight: true,
        disabled: disabled,
        renderOption: (option, param)=>{
            let { inputValue  } = param;
            const matches = match_default()(option, inputValue);
            const parts = parse_default()(option, matches);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: parts.map((part, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            fontWeight: part.highlight ? 700 : 400
                        },
                        children: part.text
                    }, index))
            });
        }
    });
};
/* harmony default export */ var v5_LongAutocomplete = (LongAutocomplete);

;// CONCATENATED MODULE: ./src/components/v5/CitiesAutocomplete.tsx






const CitiesAutocomplete = (param)=>{
    let { onChange , label , onLocate , grayVariant , disabled , hideSearchIcon , clearOnEscape  } = param;
    const [options, setOptions] = (0,react.useState)([]);
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    (0,react.useEffect)(()=>{
        (0,stateUtils/* getCityAndStatesOptions */.DX)()// @ts-expect-error TS2345: Argument of type 'Dispatch<SetStateAction<never[]>>' is not assignable to parameter of type '(value: string[]) => void | PromiseLike<void>'.
        .then(setOptions).catch(()=>setOptions([]));
    }, []);
    const inputStyles = [
        (CitiesAutocomplete_module_default()).searchbox,
        grayVariant && (CitiesAutocomplete_module_default())["gray-variant"],
        hideSearchIcon && (CitiesAutocomplete_module_default())["no-search"],
        !onLocate && (CitiesAutocomplete_module_default())["no-locate"]
    ].compact().join(" ");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "ma pos-r",
        children: [
            !hideSearchIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "".concat((CitiesAutocomplete_module_default()).searchIcon, " cIcon-search2 zIndex1 gray800 fs24 pos-a t50pc tty-50"),
                "aria-hidden": true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(v5_LongAutocomplete, {
                options,
                onChange,
                label,
                disabled,
                clearOnEscape,
                className: inputStyles
            }),
            onLocate && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                "aria-label": i18n.t("Search near me."),
                className: "cp gray800 pos-a-f bg-transparent br50 hover-gray800 hover-bg-gray50 brdn otn top0 bottom0 ma h10 w10 df aic jcc focus-bsDarkBlue3-hug t-100",
                style: {
                    right: 12
                },
                onClick: ()=>{
                    onLocate();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "cIcon-locArrow fs20 gray600",
                    "aria-hidden": true
                })
            })
        ]
    });
};
/* harmony default export */ var v5_CitiesAutocomplete = (CitiesAutocomplete);


/***/ }),

/***/ 46452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ IllustratedTextDecoration; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var src_useV5ImgSrc__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52299);



const IllustratedTextDecoration = (param)=>/*#__PURE__*/ {
    let { type , style , className , width ="100%" , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_useV5ImgSrc__WEBPACK_IMPORTED_MODULE_2__/* .V5Image */ .dZ, {
        style: {
            bottom: type === "circle" ? 1 : -14,
            ...style
        },
        src: "home/word-".concat(type),
        imgExt: "webp",
        className: "pos-a-center right0 left0 ma maxw-none zIndex-1 ".concat(className),
        width: width,
        ...props,
        alt: ""
    });
};


/***/ }),

/***/ 41843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ coronavirus; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/@c10h/colors/es/palette.js
var palette = __webpack_require__(45602);
// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var src_i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/store/index.ts + 6 modules
var store = __webpack_require__(40367);
// EXTERNAL MODULE: ./src/useMediaQuery.ts
var useMediaQuery = __webpack_require__(57974);
// EXTERNAL MODULE: ./src/components/v5/IllustratedTextDecoration.tsx
var IllustratedTextDecoration = __webpack_require__(46452);
// EXTERNAL MODULE: ./src/components/v5/V5Comp.tsx
var V5Comp = __webpack_require__(63575);
;// CONCATENATED MODULE: ./src/components/v5/Coronavirus/Overview.tsx








const Overview = (param)=>{
    let { sections  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    /*
    Currently turning off text decorations for mobile because they do not render properly.
    Inline styles are not getting passed to the <img> element with iPhone user agent.
  */ const { isMobile  } = (0,store/* useTypedSelector */.ix)((state)=>state.config);
    const isMd = (0,useMediaQuery/* default */.Z)("md");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pt40 pb20 pt24-md pb5-md ph4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "maxw40 maxw25-md ma df fdc tac",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "mb4 fs28-md pos-r",
                    children: isMd ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "mr2",
                                children: "COVID-19 Resources to keep you"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "pos-r darkerGreen",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "zIndex2 pos-r",
                                        children: [
                                            "healthy",
                                            " ",
                                            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustratedTextDecoration/* IllustratedTextDecoration */.S, {
                                                type: "blue-underline",
                                                className: "zIndex1",
                                                style: {
                                                    bottom: -1
                                                },
                                                "aria-hidden": true
                                            })
                                        ]
                                    }),
                                    "and",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "pos-r",
                                        children: [
                                            "safe",
                                            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustratedTextDecoration/* IllustratedTextDecoration */.S, {
                                                type: "blue-underline",
                                                className: "zIndex1",
                                                style: {
                                                    bottom: 2
                                                },
                                                "aria-hidden": true
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "mr2",
                                children: "COVID-19 Resources to keep you"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "pos-r",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "darkerGreen zIndex2 pos-r",
                                        children: "healthy and safe"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustratedTextDecoration/* IllustratedTextDecoration */.S, {
                                        type: "blue-underline",
                                        className: "zIndex1",
                                        style: {
                                            bottom: -4
                                        },
                                        "aria-hidden": true
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "fs20 fs18-md ls-3",
                    children: i18n.t("Explore our tools and offerings for life, work, travel and beyond.")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "dn dib-md fs28 font-csb mt10",
                    children: i18n.t("How can we help?")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "df fw aic jcc fwnw-md fdc-md mt10 mt4-md gg3",
                    children: sections.map((param)=>/*#__PURE__*/ {
                        let { id , smallTitle , icon , href  } = param;
                        return (0,jsx_runtime.jsx)("li", {
                            className: "t-150",
                            "data-cy": id,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(V5Comp/* Btn */.un, {
                                href: href || "#".concat(id),
                                color: palette.gray800,
                                hover: "#fff",
                                bg: palette.gray100,
                                hoverBg: palette.gray800,
                                className: "pos-r focus-bsDarkBlue3",
                                onClick: ()=>{
                                    // @ts-expect-error TS2531: Object is possibly 'null'.
                                    if (!href) document.getElementById(id).focus();
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "cIcon-".concat(icon, " fs22 pos-a"),
                                        style: {
                                            left: 16,
                                            top: "50%",
                                            transform: "translateY(-50%)"
                                        },
                                        "aria-hidden": true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-ib ml5",
                                        children: smallTitle
                                    })
                                ]
                            })
                        }, id);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Coronavirus_Overview = (Overview);

// EXTERNAL MODULE: ./src/components/v5/NextImage.tsx + 1 modules
var NextImage = __webpack_require__(5621);
// EXTERNAL MODULE: ./src/components/v5/CitiesAutocomplete.tsx + 1 modules
var CitiesAutocomplete = __webpack_require__(98196);
;// CONCATENATED MODULE: ./src/components/v5/Coronavirus/Section.tsx







const isButtonVariant = (section)=>"btnProps" in section;
const Section = (param)=>{
    let { section  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const [selected, setSelected] = (0,react.useState)();
    const onValueChange = (e, value)=>{
        setSelected(value);
    };
    const isXs = (0,useMediaQuery/* default */.Z)("xs");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "df minh110 pos-r fdc-md aic-md br3-md bs2-md maxw25-md",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                id: section.id,
                className: "pos-a",
                style: {
                    top: -60
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fx2 pt10 pb5 pl2 p6-md pr4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "df fdc maxw25",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "fs32 fs28-md mb4-md",
                            children: section.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "fs20 fs18-md mb5",
                            children: section.subtitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "df aic fdrr jcfe fdc-md aifs-md",
                            children: [
                                isButtonVariant(section) && section.line1 && section.line2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "df fdc jcc ml3 mb5-md ml0-md",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "font-csb fs18 mb1",
                                            children: section.line1
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "font-ir fs14",
                                            children: section.line2
                                        })
                                    ]
                                }),
                                isButtonVariant(section) && /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                                    ...section.btnProps,
                                    className: "w100p-f-md focus-bsDarkBlue3"
                                }),
                                !isButtonVariant(section) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                    className: "pos-r w100p df aic",
                                    onSubmit: (e)=>{
                                        e.preventDefault();
                                        section.onSearch(selected);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w100p",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CitiesAutocomplete/* default */.Z, {
                                                label: isXs ? i18n.t("City or State") : i18n.t("Enter a city and state"),
                                                onChange: onValueChange,
                                                onLocate: ()=>{
                                                    section.onSearch();
                                                },
                                                grayVariant: true,
                                                hideSearchIcon: true,
                                                clearOnEscape: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            role: "link",
                                            type: "submit",
                                            "aria-label": i18n.t("Search in this location."),
                                            className: "brdn df tac p3 br50 ml2 t-100 bg-gray800 hover-bg-gray600 cp focus-bsDarkBlue3-hug",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cIcon-search2 zIndex1 white fs26"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fx3 w100p-md minh58-md df",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pos-r df fx",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                        src: section.src,
                        alt: section.alt,
                        layout: "fill",
                        className: "br3 br3b-md",
                        priority: section.id === "find-testing"
                    })
                })
            })
        ]
    }, section.id);
};
/* harmony default export */ var Coronavirus_Section = (Section);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(21395);
// EXTERNAL MODULE: ./src/components/_common/_constants.ts + 1 modules
var _constants = __webpack_require__(93932);
// EXTERNAL MODULE: ./src/utils/stateUtils.ts + 1 modules
var stateUtils = __webpack_require__(83202);
// EXTERNAL MODULE: ./src/constants/CovidTravelClearanceConstants.tsx
var CovidTravelClearanceConstants = __webpack_require__(51393);
;// CONCATENATED MODULE: ./src/constants/CoronavirusConstants.tsx







const useCoronavirusConstants = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const isMd = (0,useMediaQuery/* default */.Z)("md");
    return [
        {
            id: "get-tested",
            title: i18n.t("Find COVID-19\ntesting near you "),
            smallTitle: i18n.t("Get Tested"),
            subtitle: i18n.t("Choose by test type, proximity or availability"),
            icon: "microscope",
            src: "/coronavirus/yellow-map-testing",
            alt: i18n.t("A static map with a marker at a Carbon Health COVID testing location."),
            href: {
                pathname: _constants/* v5Pages.getCareSlug */.Td.getCareSlug,
                query: {
                    slug: "covid-19-testing"
                }
            },
            // @ts-expect-error TS2322: Type '(cityAndState: string) => void' is not assignable to type '(cityAndState?: string | undefined) => void'.
            onSearch: (cityAndState)=>{
                const [city, state] = (0,stateUtils/* getCityAndState */.WY)(cityAndState);
                const pathname = _constants/* v5Pages.covid19TestingCenters */.Td.covid19TestingCenters;
                const as = [
                    pathname,
                    state === null || state === void 0 ? void 0 : state.replaceAll(" ", "-"),
                    city === null || city === void 0 ? void 0 : city.replaceAll(" ", "-")
                ].compact().join("/");
                router.push({
                    pathname,
                    query: {
                        state,
                        city
                    }
                }, as);
            }
        },
        {
            id: "travel-safely",
            title: i18n.t("Get cleared for travel"),
            smallTitle: i18n.t("Travel Safely"),
            subtitle: i18n.t("Plan for travel and book a COVID-19 test to ensure safety and peace of mind"),
            icon: "plane",
            btnProps: {
                link: true,
                href: {
                    pathname: _constants/* v5Pages.covid19TravelClearance */.Td.covid19TravelClearance
                },
                children: i18n.t("Travel Safely"),
                hoverBg: "".concat(palette.gray800, "E6")
            },
            line1: i18n.t("{{price}} / person", {
                price: CovidTravelClearanceConstants/* minMaxTravelClearancePrices */.tY
            }),
            line2: i18n.t("Insurance not accepted"),
            src: "/coronavirus/woman-with-mask-in-airplane",
            alt: i18n.t("A woman wearing a mask in an airplane.")
        },
        {
            id: "covid-care",
            title: i18n.t("On-demand care for patients with COVID-19"),
            smallTitle: i18n.t("Seek COVID-19 Care"),
            subtitle: i18n.t("Get relief, comfort, and expert COVID-19 care from the comfort of your home today"),
            icon: "virus-molecule",
            btnProps: {
                link: true,
                href: {
                    pathname: _constants/* v5Pages.covidPositiveCare */.Td.covidPositiveCare
                },
                children: i18n.t("Explore Care"),
                hoverBg: "".concat(palette.gray800, "E6")
            },
            src: "/coronavirus/person-looking-at-phone",
            alt: i18n.t("A person looking at her phone.")
        },
        {
            id: "employer-solutions",
            title: i18n.t("COVID-19 solutions for employers"),
            smallTitle: isMd ? i18n.t("Workplace Readiness") : i18n.t("Enterprise Workplace Readiness"),
            subtitle: i18n.t("Maintain a safe work environment and manage COVID-19 risk with testing, vaccine tracking and more"),
            icon: "clipboard",
            btnProps: {
                link: true,
                href: {
                    pathname: _constants/* v5Pages.covidReadyCompliance */.Td.covidReadyCompliance
                },
                children: i18n.t("Learn More"),
                hoverBg: "".concat(palette.gray800, "E6")
            },
            src: "/coronavirus/people-working",
            alt: i18n.t("Two women in a bright office working together.")
        },
        {
            id: "get-vaccinated",
            title: i18n.t("Find a vaccine\nprovider near you"),
            smallTitle: i18n.t("Get Vaccinated"),
            subtitle: i18n.t("Choose by vaccine type, proximity, or availability"),
            icon: "syringe-and-vial",
            src: "/coronavirus/blue-map-vaccine",
            alt: i18n.t("A static map with a marker at a Carbon Health COVID vaccine location."),
            // @ts-expect-error TS2322: Type '(cityAndState: string) => void' is not assignable to type '(cityAndState?: string | undefined) => void'.
            onSearch: (cityAndState)=>{
                const [city, state] = (0,stateUtils/* getCityAndState */.WY)(cityAndState);
                const pathname = _constants/* v5Pages.vaccineNearMe */.Td.vaccineNearMe;
                const as = [
                    pathname,
                    state === null || state === void 0 ? void 0 : state.replaceAll(" ", "-"),
                    city === null || city === void 0 ? void 0 : city.replaceAll(" ", "-")
                ].compact().join("/");
                router.push({
                    pathname,
                    query: {
                        state,
                        city
                    }
                }, as);
            }
        }
    ];
};

// EXTERNAL MODULE: ./src/components/v5/Layout.tsx + 29 modules
var Layout = __webpack_require__(32122);
;// CONCATENATED MODULE: ./src/pages/coronavirus.tsx







const Coronavirus = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const pageTitle = i18n.t("Coronavirus resources for testing, vaccines, safe travel & more");
    const pageDescription = i18n.t("Explore Carbon Health’s COVID-19 tools and offerings for staying safe and healthy as the coronavirus pandemic continues to shift and change over time.");
    const pageImage = "coronavirus";
    const sections = useCoronavirusConstants();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        pageTitle: pageTitle,
        pageDescription: pageDescription,
        pageImage: pageImage,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Coronavirus_Overview, {
                sections: sections
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ph4 pt8 pt4-md pb20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "maxw72 ma dg gafr gg12 gg6-md jcc-md",
                    children: sections.map((section)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Coronavirus_Section, {
                            section: section
                        }, section.id))
                })
            })
        ]
    });
};
/* harmony default export */ var coronavirus = (Coronavirus);


/***/ }),

/***/ 93408:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"searchbox":"CitiesAutocomplete_searchbox__6ttNs","gray-variant":"CitiesAutocomplete_gray-variant__HA0II","no-search":"CitiesAutocomplete_no-search__MaMLh","no-locate":"CitiesAutocomplete_no-locate__bdHFh","searchIcon":"CitiesAutocomplete_searchIcon__M8nCr"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2745,3014,2493,9983,6282,2122,620,9774,2888,179], function() { return __webpack_exec__(33809); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);